import React from 'react';

const Navbar = () => {
  const state = localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : [];
  const quantity = state.reduce((acc, curr) => {
    return acc + curr.qty;
  }, 0);

  const navLinks = [
    {
      title: 'Women',
      link: '/category/women',
    },
    {
      title: 'Men',
      link: '/category/men',
    },
    {
      title: 'Accessories',
      link: '/category/accessories',
    },
  ];

  return (
    <nav
      className='navbar navbar-expand-lg py-3 sticky-top'
      style={{ borderBottom: '1px solid #ddd', background: '#fff' }}>
      <div className='container'>
        <a href='/' className='navbar-brand fw-bold fs-4'>
          <span style={{ fontWeight: 500 }}>QUINSHOP</span>
        </a>
        {window.location.pathname !== '/summary' && (
          <>
            <ul className='navbar-nav mb-2 mb-lg-0'>
              {navLinks.map((link, index) => {
                return (
                  <li className='nav-item mx-2' key={index}>
                    <a href={link.link} className='nav-link'>
                      {link.title}
                    </a>
                  </li>
                );
              })}
            </ul>

            <div className='flex-grow-0' id='navbarSupportedContent'>
              <div className='buttons d-flex align-items-center justify-content-center gap-1'>
                <button
                  type='button'
                  className='btn border-0 p-0 d-flex align-items-center'
                  data-bs-toggle='modal'
                  data-bs-target='#exampleModal'
                  data-gtm-click='iletisim-popup|İletişime geç'
                  style={{ background: 'transparent' }}>
                  <img src='../../icons/user-circle.svg' alt='profile' className='mx-2' />
                </button>
                <img src='../../icons/heart.svg' alt='heart' className='mx-2' style={{ cursor: 'pointer' }} />
                <a href='/cart' className='cart-icon-wrapper d-flex align-items-center'>
                  <img src='../../icons/shopping-bag.svg' alt='cart' className='mx-2' />
                  <span className='cart-badge'>{quantity}</span>
                </a>
              </div>
            </div>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
